import { MarketingAllBenefits } from "../../../components/MarketingAllBenefits";
import { MarketingFooter } from "../../../components/MarketingFooter";
import { MarketingGetStarted } from "../../../components/MarketingGetStarted";
import { MarketingIconBlock, MarketingIconsBlock } from "../../../components/MarketingIconsBlock";
import { MarketingMenu } from "../../../components/MarketingMenu";
import { MarketingOGTags } from "../../../components/MarketingOGTags";
import { MarketingTextSVGColumn } from "../../../components/MarketingTextSVGColumn";
import { AnalyzeContentSVGDesktop, MarketingTextSVGCTA, MarketingTextSVGHeader } from "../../../components/MarketingTextSVGHeader";
import { MarketingUserPledge } from "../../../components/MarketingUserPledge";
import { FadeUpContainer } from "../../../components/ReusableStyledComponents/FadeUp";
import { MarketingTitleBr } from "../../../components/ReusableStyledComponents/MarketingMainTitle";
import { SVGGeneric } from "../../../components/ReusableStyledComponents/SVGGeneric";
import { VerticalSpacing } from "../../../components/VerticalSpacing";
import { theme } from "../../../theme/theme";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

export const AnalyticsMarketingPageLayout = () => {
    return (
        <>
            <MarketingOGTags
                title="Authory – Get social media analytics for your content now"
                description="Find out how many tweets, comments, mentions, pins, likes and more your content receives."
                canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.ANALYTICS_MARKETING}`}
            />
            <MarketingMenu />
            <FadeUpContainer>
                <VerticalSpacing
                    top={0}
                    breakpoints={[
                        { screen: theme.breakpoints.tablet, marginTop: 20 },
                        { screen: theme.breakpoints.desktop, marginTop: 70 }
                    ]}
                >
                    <MarketingTextSVGHeader
                        subtitle="Analytics"
                        title={
                            <>
                                Find out{" "}
                                <strong>
                                    how your content <MarketingTitleBr /> performs
                                </strong>{" "}
                                on social media
                            </>
                        }
                        description={
                            <>
                                <strong>Before:</strong> Trying to figure out how the content you create performs on social media is a nightmare.{" "}
                                <strong>After:</strong> Visually stunning analytics tell you exactly how often your content has been shared, tweeted
                                or liked on all big social media networks.
                                <MarketingTextSVGCTA text="Get social media analytics for your content now" />
                            </>
                        }
                        desktopSVG={<AnalyzeContentSVGDesktop />}
                        mobileSVG={<img src="/authory_static_files/images/features/analyze/analyze_header_mobile.png" />}
                        mobileMaxWidth={467}
                        textMaxWidth={900}
                        containerMaxWidth={1420}
                        desktopImage={"/authory_static_files/images/features/analyze/analyze_header_desktop.svg"}
                        desktopImageWidth={1296}
                        desktopImageHeight={518}
                        desktopImageMarginTop={150}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Analytics for your entire career"}
                        title={
                            <>
                                <strong>Past and future</strong>
                                <br /> included
                            </>
                        }
                        description={
                            <>
                                Social media analytics are available for all your content, making it easy for you to get a complete picture across
                                your entire publishing career.
                            </>
                        }
                        desktopImgWidth={656}
                        desktopImgHeight={296}
                        desktopImage={"/authory_static_files/images/features/analyze/pastfuture_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/analyze/pastfuture_mobile.jpg"}
                        snapBr={1220}
                        mobileMaxWidth={391}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Holistic content performance"}
                        title={
                            <>
                                <strong>Go beyond</strong> your
                                <br /> personal accounts
                            </>
                        }
                        description={
                            <>
                                Authory will tell you about the social media interactions your content has created by any (!) account, not just your
                                personal ones or the ones by your publisher.
                            </>
                        }
                        svgPosition="left"
                        desktopImgWidth={526}
                        desktopImgHeight={381}
                        desktopImage={"/authory_static_files/images/features/analyze/beyond_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/analyze/beyond_mobile.jpg"}
                        mobileMaxWidth={400}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Comprehensive analytics"}
                        title={
                            <>
                                <strong>The big picture,</strong>
                                <br />
                                yet laser focussed
                            </>
                        }
                        description={
                            <>
                                Learn how your contents' aggregate reach on social media has changed over time, or check the performance of individual
                                pieces within seconds.
                            </>
                        }
                        desktopImgWidth={628}
                        desktopImgHeight={439}
                        desktopImage={"/authory_static_files/images/features/analyze/bigpicture_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/analyze/bigpicture_mobile.png"}
                        snapBr={1210}
                        mobileMaxWidth={381}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Powerful filters"}
                        title={
                            <>
                                Surface what's <br />
                                <strong>most interesting</strong>
                            </>
                        }
                        description={
                            <>
                                Your most shared piece on Twitter in 2018? The most successful article you've written on autonomous driving so far?
                                Your video with the most comments? With Authory all that, and much more, is at your fingertips anytime.
                            </>
                        }
                        svgPosition="left"
                        desktopImgWidth={601}
                        desktopImgHeight={354}
                        desktopImage={"/authory_static_files/images/features/analyze/surface_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/analyze/surface_mobile.jpg"}
                        snapBr={1150}
                        mobileMaxWidth={391}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingTextSVGColumn
                        subtitle={"Weekly email reports"}
                        title={
                            <>
                                Know about
                                <br />
                                <strong> your evergreens</strong>
                            </>
                        }
                        description={
                            <>
                                All your content will be monitored continuously and you'll be notified if an evergreen piece starts to gain traction
                                again.
                            </>
                        }
                        desktopImgWidth={556}
                        desktopImgHeight={396}
                        desktopImage={"/authory_static_files/images/features/analyze/knowabout_desktop.png"}
                        mobileImage={"/authory_static_files/images/features/analyze/knowabout_mobile.png"}
                        snapBr={1150}
                        mobileMaxWidth={343}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingIconsBlock
                        icons={[
                            <MarketingIconBlock
                                title={
                                    <>
                                        Keep your <strong>prized data</strong>
                                    </>
                                }
                                text={
                                    <>
                                        The data about the performance of your articles on social media is a real treasure trove. And wherever you go
                                        next, Authory and all your analytics data will stay with you.
                                    </>
                                }
                                icon={<SVGGeneric src="/authory_static_files/images/icons/keep_data.svg" />}
                                minHeight={134}
                            />,
                            <MarketingIconBlock
                                title={
                                    <>
                                        Let the reports <strong>come to you</strong>
                                    </>
                                }
                                text={
                                    <>
                                        Get the important metrics of the week via email, making sure you'll never miss out on anything without having
                                        to continuously check. Being up to date has never been easier.
                                    </>
                                }
                                icon={<SVGGeneric src="/authory_static_files/images/icons/detailed_statistics.svg" />}
                                minHeight={134}
                            />
                        ]}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingUserPledge
                        title={
                            <>
                                “<strong>I couldn’t live without Authory now</strong> and I think anyone else like me would feel the same quickly
                                after using it.”
                            </>
                        }
                        description={
                            <>
                                <strong>Chris Pike,</strong> AAP, ESPN and more
                            </>
                        }
                        avatarImage={"/authory_static_files/images/pledges/Chris.jpg"}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120}>
                    <MarketingGetStarted />
                </VerticalSpacing>
                <MarketingAllBenefits currRoute={APPLICATION_ROUTES.ANALYTICS_MARKETING} />
                <MarketingFooter backgroundColor="white" />
            </FadeUpContainer>
        </>
    );
};
